let { monkey } = require('baobab');
let _ = require('lodash');

const LINKS = {
    client: [
        {
            name: 'account',
            href: '/account/orders',
            title: 'Заказы'
        },
        {
            name: 'contacts',
            href: '/contacts',
            title: 'О нас'
        }
    ],
    manager: [
        {
            name: 'manager',
            href: '/manager/orders',
            title: 'Панель менеджера'
        },
        {
            name: 'contacts',
            href: '/contacts',
            title: 'О нас'
        }
    ],
    unauthorized: [
        {
            name: 'contacts',
            href: '/contacts',
            title: 'О нас'
        }
    ]
};

module.exports = {
    /**
     * Устанавливаем меню в шапке
     * @param {Object} args
     * @param {Object} state
     * @param {Function} output
     * @param {Object} services
     * @param {Object} services.locator
     */
    setHeaderMenu (args, state) {
        state.set(['header', 'menu'], monkey(
            ['page', 'name'],
            ['user', 'role'],
            (page, role) => _.chain(LINKS)
                .get(role)
                .map((link) => Object.assign({}, link, { isActive: link.name === page }))
                .value()
        ));
    }
};




// WEBPACK FOOTER //
// ./actions/layout/header.js